module.exports = __webpack_public_path__ + "static/media/customer-service.9a2a5260.png";